import { ReceptionChatInteractive } from '@components/chat/ReceptionChatInteractive'

export function HomePage() {
  return (
    <div className="h-full flex flex-col">
      {/* AI Chat Interface */}
      <div className="flex-1 min-h-[600px]">
        <ReceptionChatInteractive className="h-full" />
      </div>
    </div>
  )
}
